// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-avatar{align-items:center;border-radius:50%;display:inline-flex;justify-content:center;line-height:normal;position:relative;text-align:center;vertical-align:middle;overflow:hidden}.v-avatar img,.v-avatar svg,.v-avatar .v-icon,.v-avatar .v-image,.v-avatar .v-responsive__content{border-radius:inherit;display:inline-flex;height:inherit;width:inherit}", ""]);
// Exports
module.exports = exports;
